import { Flex, Button, Text, SettingsIcon } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

import { useSidePanelButtonStyles } from "./SidePanelButton.styles";
import { SidePanelButtonProps } from "./SidePanelButton.types";

export const SidePanelButton: React.FC<SidePanelButtonProps> = ({
  togglePanelOpen,
  isInfoFetched,
}) => {
  const sidePanelButtonStyles = useSidePanelButtonStyles();
  const { t } = useTranslation();

  return (
    <Flex>
      <Flex.Item push>
        <Button
          data-testid="openSidePanel"
          aria-label={t("CHANGE_AUDIO_VIDEO")}
          onClick={togglePanelOpen}
          disabled={!isInfoFetched}
          styles={sidePanelButtonStyles.sidePanelButton}
          icon={<SettingsIcon />}
          iconPosition="before"
          secondary
          content={
            <Text
              content={<>{t("CHANGE_AUDIO_VIDEO")}</>}
              size="medium"
              weight="semibold"
              align="center"
            />
          }
        />
      </Flex.Item>
    </Flex>
  );
};
